import type { App } from 'vue'
import { defineAsyncComponent } from 'vue'
import Drawer from './drawer'
// import General from './general'
import Table from './table'
import Catalog from './catalog'
import FiltersView, { LoadableFiltersView } from './filter';


import {
  Sidebar,
  SidebarMenu,
  SidebarMenuElement,
  SidebarMenuLink,
  SidebarMenuNested,
  SidebarMenuSection,
} from './sidebar';
const CabinetHeader = defineAsyncComponent(() => import('./sections/CabinetHeader.vue'))
const CabinetBody = defineAsyncComponent(() => import('./sections/CabinetBody.vue'))
const CabinetFooter = defineAsyncComponent(() => import('./sections/CabinetFooter.vue'))


export default {
  install(app: App<Element>, { prefix = 'Cabinet'} = {}): void {
    app
      .use(Drawer)
      // .use(General)
      .use(Table)
      .use(Catalog)

      .component(`${prefix}Header`, CabinetHeader)
      .component(`${prefix}Body`, CabinetBody)
      .component(`${prefix}Footer`, CabinetFooter)

      .component(`${prefix}Sidebar`, Sidebar)
      .component(`${prefix}SidebarMenu`, SidebarMenu)
      .component(`${prefix}SidebarMenuElement`, SidebarMenuElement)
      .component(`${prefix}SidebarMenuLink`, SidebarMenuLink)
      .component(`${prefix}SidebarMenuSection`, SidebarMenuSection)
      .component(`${prefix}SidebarMenuNested`, SidebarMenuNested)

      .component('UiFiltersView', FiltersView)
      .component('UiLoadableFiltersView', LoadableFiltersView)
  }
}
